
import {
    QTabs,
    QTab
} from 'quasar'
import Vue from 'vue'
import types from '../helpers/types'
import ListTable from '../components/ListTable.vue'
import { plzDistance, plzMap } from '../helpers/plz'
import { isFuture } from 'date-fns';

export default Vue.extend({
    components: { QTabs, QTab, ListTable },
    props: {
        listId: {
            type: String,
            default: ''
        },
        entries: {
            type: Array,
            default: () => []
        },
        filter: {
            type: Object,
            default: () => ({})
        },
        allowSelection: {
            type: Boolean,
            default: false
        },
        selectedEntries: {
            type: Array,
            default: () => []
        },
        sharingListId: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            filterType: 'producer'
        }
    },
    computed: <any>{
        types() {
            let keys = {}

            for(let el of this.filtered) {
                keys[el.type] = true
            }

            return Object.keys(keys).map(key => {
                return types.find(t => t.key == key)
            })
        },
        distanceTo() {
            return plzMap[this.filter.postcode]
        },
        filteredWithType() {
            return this.filtered.filter(e => e.type == this.filterType)
        },
        filtered() {
            let list = this.entries


            // sharing mode?
            if(this.sharingListId) {
                list = list.filter(e => {
                    if(!e.isInList) return false // sharing is only allowed for entries we own
                    if(e.listIds.includes(this.sharingListId)) return false // list already contains this entry
                    return true
                })
            }

            if(this.filter.query) {
                let searchRegex: RegExp
                try {
                    searchRegex = new RegExp(this.filter.query, 'im')
                    ''.match(searchRegex)
                } catch(err) {
                    searchRegex = /INVALID/
                    console.log(err)
                }
                list = list.filter(e => {
                    const str = [
                        e.id,
                        e.name,
                        e.tel,
                        e.mail,
                        e.contactPerson,
                        e.comment,
                        e.postcode,
                        e.website,
                        e.products,
                        e.responsible

                    ].join('\n')
                    if(str.match(searchRegex)) return true
                    return false
                })
            } else {
                if(this.filter.isResponsibleActive && this.filter.responsible) {
                    const responsible = this.filter.responsible.toLowerCase()
                    list = list.filter(e => {
                        if(!e.responsible) return false
                        if(e.responsible.toLowerCase().indexOf(responsible) !== -1) return true
                        return false
                    })
                }
                
                if(this.filter.onlyActive) {
                    list = list.filter(e => {
                        const state = e.lastState
                        if(!e.isInList) return false
                        if(!state.pausedUntil) return true
                        return !isFuture(state.pausedUntil)
                    })
                }

                if(this.filter.state && this.filter.isStateActive) {
                    list = list.filter(e => {
                        const state = e.lastState
                        if(!state) return false
                        return state.key == this.filter.state
                    })
                }

                if(this.filter.isDistanceActive && this.filter.postcode && this.filter.distance !== null) {
                    list = list.filter(e => {
                        if(plzDistance(this.filter.postcode, e.postcode) < this.filter.distance) return true
                        return false
                    })
                }
            }
            return list
        }
    }
})
